import React, { useEffect } from "react";

import { useAddSourceFile } from "@/api/knowledge-source/add-source-file";
import FileDrop from "@/components/ui/file-drop";
import { Progress } from "@/components/ui/progress";
import useGlobalLoading from "@/store/global-loading";

import KnowledgeSourceButtons from "../knowledge-source-buttons/knowledge-source-buttons";

const CSVSource = () => {
    const [file, setFile] = React.useState<File | null>(null);

    const { mutate: addCSV, isPending, progress, isSuccess } = useAddSourceFile();

    const { setIsLoading } = useGlobalLoading();

    useEffect(() => {
        if (isSuccess && !isPending) {
            setFile(null);
        }
    }, [isSuccess, isPending]);

    const handleAddSource = () => {
        const formData = new FormData();
        if (file) {
            formData.append("file", file);
        }
        addCSV({ file: file });
    };

    useEffect(() => {
        setIsLoading(isPending);
    }, [isPending, setIsLoading]);
    return (
        <div>
            <FileDrop fileType="CSV" fileSetter={setFile} file={file} />
            {file && <Progress className="mt-4" value={progress} />}
            <div className="mt-4 border-t p-4">
                <KnowledgeSourceButtons onSubmit={handleAddSource} loading={isPending} />
            </div>
        </div>
    );
};

export default CSVSource;
